// extracted by mini-css-extract-plugin
module.exports = {"image":"ImageForm_image__3HVCZ"};